module.exports = __webpack_public_path__ + "media/images/png/newsletter_logo-5ba326eaf21c21a8685d695847a08293.png";